import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const API_ENTITIES_BASE = "/admin/entities";

export async function getEntities() {

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.get(API_ENTITIES_BASE, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export async function createEntity(payload) {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.post(API_ENTITIES_BASE, payload, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export async function updateEntity(payload) {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.put(API_ENTITIES_BASE, payload, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export async function deleteEntity(entityId) {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const query = new URLSearchParams({ id: entityId }).toString();

    const res = await AxiosInstance.delete(`${API_ENTITIES_BASE}?${query}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

const EntitiesService = {
  getEntities,
  createEntity,
  updateEntity,
  deleteEntity,
};

export default EntitiesService;
